export enum ProtocolPipelineTopology {
  TABLE = "ProtocolPipeline",
  PIPELINE = "pipeline",
  METHOD_TYPE = "methodType",
}
